import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=54bbb42c&scoped=true&"
import script from "./SendEmail.vue?vue&type=script&lang=js&"
export * from "./SendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bbb42c",
  null
  
)

export default component.exports